/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import FolderAdd from '@spectrum-icons/workflow/FolderAdd';
import More from '@spectrum-icons/workflow/More';
import OpenIn from '@spectrum-icons/workflow/OpenIn';
import UserAdd from '@spectrum-icons/workflow/UserAdd';
import Share from '@spectrum-icons/workflow/Share';
import Rename from '@spectrum-icons/workflow/Rename';
import Duplicate from '@spectrum-icons/workflow/Duplicate';
import MoveTo from '@spectrum-icons/workflow/MoveTo';
import ViewCard from '@spectrum-icons/workflow/ViewCard';
import Delete from '@spectrum-icons/workflow/Delete';
import { AiOutlineFileAdd, AiOutlineEdit, AiTwotoneEdit } from 'react-icons/ai';
import {
  DialogTrigger,
  ActionButton,
  Dialog,
  Heading,
  Button,
  Content,
  Form,
  Flex,
  TextField,
  Text,
  ButtonGroup,
  TooltipTrigger,
  Tooltip,
  Link,
  Divider,
} from '@adobe/react-spectrum';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { createProof } from '../assets/workfrontfileutils';
import handleNewFolderCreation, { handleFileUpload } from './fileHelper';

function SideMenu(props) {
  const {
    ims,
    wfObjectCodeAndID,
    isSelected,
    rowSelected,
    handleSubFolderData,
    currentPath,
  } = props;
  const [value, setValue] = useState('');
  const [uploadedFile, setUploadedFile] = useState();
  const [proof, setProof] = useState(false);
  const [openProof, setOpenProof] = useState(false);
  const [proofID, setProofID] = useState('');
  const [versionID, setVersionID] = useState('');
  useEffect(() => {
    setValue('');
    if (rowSelected?.isFileIcon && rowSelected?.platformName === 'Workfront') {
      rowSelected.versions.map(version => {
        if (version.ID === rowSelected.currentVersionID) {
          if (version.proofStatus === 'success') {
            setOpenProof(true);
            setProof(false);
            setProofID(version.proofID);
          } else {
            setProof(true);
            setOpenProof(false);
            setVersionID(version.ID);
          }
        }
        return null;
      });
    } else {
      setProof(false);
      setOpenProof(false);
    }
  }, [rowSelected]);

  return (
    <>
      {!isSelected ? (
        <div className="iconMenu">
          <TooltipTrigger delay={0} placement="end">
            <ActionButton isQuiet>
              <FolderAdd size="S" />
            </ActionButton>
            <Tooltip>Create a folder</Tooltip>
          </TooltipTrigger>
          <div className="icon">
            <ActionButton isQuiet>
              <More size="S" />
            </ActionButton>
          </div>
        </div>
      ) : (
        <div className="iconMenu">
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <DialogTrigger>
                <ActionButton isQuiet>
                  <FolderAdd size="S" />
                </ActionButton>
                {close => (
                  <Dialog width="304px" height="256">
                    <Heading>
                      <Flex alignItems="center" gap="size-100">
                        <Text>Create new folder</Text>
                      </Flex>
                    </Heading>
                    <Content>
                      <Form>
                        <TextField
                          label="Folder name"
                          placeholder="name"
                          value={value}
                          onChange={setValue}
                        />
                        <TextField
                          label="Path"
                          placeholder="path"
                          value={`${rowSelected.name} /${value}`}
                        />
                        <TextField
                          label="Add folder to"
                          placeholder="name"
                          value={rowSelected.platformName}
                        />
                      </Form>
                    </Content>
                    <ButtonGroup right="54px">
                      <Button
                        variant="cta"
                        onPress={() => {
                          handleNewFolderCreation(
                            rowSelected,
                            wfObjectCodeAndID,
                            handleSubFolderData,
                            value,
                            ims,
                            currentPath,
                          );
                          close();
                        }}
                      >
                        Create
                      </Button>
                      <Button variant="secondary" onPress={close}>
                        Cancel
                      </Button>
                    </ButtonGroup>
                  </Dialog>
                )}
              </DialogTrigger>
              <Tooltip>Create a folder</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <OpenIn size="S" />
              </ActionButton>
              <Tooltip>Open</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <UserAdd size="S" />
              </ActionButton>
              <Tooltip>Invite to edit</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <DialogTrigger>
                <ActionButton isQuiet>
                  <AiOutlineFileAdd size={20} />
                </ActionButton>
                {close => (
                  <Dialog width="400px" height="256">
                    <Heading>
                      <Flex alignItems="center" gap="size-100">
                        <Text>Upload a file to Creative Cloud</Text>
                      </Flex>
                    </Heading>
                    <Content>
                      <DropzoneAreaBase
                        showPreviews
                        showFileNamesInPreview
                        onAdd={val => setUploadedFile(val)}
                        maxFileSize={300000000}
                      />
                    </Content>
                    <ButtonGroup right="54px">
                      <Button
                        variant="cta"
                        onPress={() => {
                          handleFileUpload(
                            ims,
                            uploadedFile,
                            wfObjectCodeAndID,
                            rowSelected,
                            handleSubFolderData,
                            setUploadedFile,
                          );
                          close();
                        }}
                      >
                        Upload
                      </Button>
                      <Button variant="secondary" onPress={close}>
                        Cancel
                      </Button>
                    </ButtonGroup>
                  </Dialog>
                )}
              </DialogTrigger>
              <Tooltip>Upload a asset</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <Share size="S" />
              </ActionButton>
              <Tooltip>Share</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <Rename size="S" />
              </ActionButton>
              <Tooltip>Rename</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <Duplicate size="S" />
              </ActionButton>
              <Tooltip>Duplicate</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <MoveTo size="S" />
              </ActionButton>
              <Tooltip>Move to</Tooltip>
            </TooltipTrigger>
          </div>
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <ViewCard size="S" />
              </ActionButton>
              <Tooltip>Wallmode</Tooltip>
            </TooltipTrigger>
          </div>
          {proof && (
            <div className="icon">
              <TooltipTrigger delay={0} placement="end">
                <DialogTrigger>
                  <ActionButton isQuiet>
                    <AiOutlineEdit size="22" />
                  </ActionButton>
                  {close => (
                    <Dialog width="304px" height="256">
                      <Heading>
                        <Flex alignItems="center" gap="size-100">
                          <Text>Create proof</Text>
                        </Flex>
                      </Heading>
                      <Divider />
                      <Content>Press Create to Create Proof</Content>
                      <ButtonGroup right="54px">
                        <Button
                          variant="cta"
                          onPress={() => {
                            createProof(rowSelected.ID, versionID);
                            setProof(false);
                            close();
                          }}
                        >
                          Create
                        </Button>
                        <Button variant="secondary" onPress={close}>
                          Cancel
                        </Button>
                      </ButtonGroup>
                    </Dialog>
                  )}
                </DialogTrigger>
                <Tooltip>Create proof</Tooltip>
              </TooltipTrigger>
            </div>
          )}
          {openProof && (
            <div className="icon">
              <TooltipTrigger delay={0} placement="end">
                <ActionButton isQuiet>
                  <Link variant="secondary" isQuiet>
                    <a
                      href={`${rowSelected.workfrontEndpoint}/document/${rowSelected.ID}/proof/${proofID}/view/`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AiTwotoneEdit size="22" />
                    </a>
                  </Link>
                </ActionButton>
                <Tooltip>Open proof</Tooltip>
              </TooltipTrigger>
            </div>
          )}
          <div className="icon">
            <TooltipTrigger delay={0} placement="end">
              <ActionButton isQuiet>
                <Delete size="S" />
              </ActionButton>
              <Tooltip>Delete</Tooltip>
            </TooltipTrigger>
          </div>
        </div>
      )}
    </>
  );
}

export default SideMenu;
